module.exports = __webpack_public_path__ + "static/media/w (13).6169e743.jpg";